// evita quebrar quando o localStorage guarda "undefined" (string) em vez de null
export function safeJSONParse(value, fallback = null) {
	if (!value || value === 'undefined') return fallback;
	try {
		return JSON.parse(value);
	} catch {
		return fallback;
	}
}
